<template>
	<div>
		<template v-if="!forcedFollowUp && !makeAppointmentSuccess">
			<FormGroup
				v-if="followUpOptions && followUpOptions.length > 1"
				class="mt-2"
				label="Jetzt bist du wieder dran. Was willst du tun?"
				:label-classes="['font-weight-bold']"
			>
				<RadioGroup
					v-model="followUp"
					:options="followUpOptions"
					stacked
					class="mt-3"
				/>
			</FormGroup>
		</template>
		<div v-if="computedFollowUp" class="mt-4">
			<template v-if="computedFollowUp === followUps.makeAppointment">
				<MakeAppointment
					:message="message"
					:applicant-name="applicantName"
					:action="actionMakeAppointment"
					with-cancel-button
					@success="$emit('processed')"
					@cancel="$emit('cancel')"
				/>
			</template>
			<template v-if="computedFollowUp === followUps.requestVita">
				<RequestVita
					:loading="sendingRequest"
					@cancel="followUp = undefined"
					@request="requestVita"
				/>
			</template>
		</div>
	</div>
</template>
<script>
import Button from "@/vue/common/Button";
import RadioGroup from "@/vue/common/form/RadioGroup";
import FormGroup from "@/vue/common/form/Group";
import InfoBox from "@/vue/common/InfoBox";
import MakeAppointment from "@/vue/communication/conversation/message/reply/MakeAppointment";
import Reply, {ACTION_MAKE_APPOINTMENT, ACTION_REQUEST_VITA} from "@/api/communication/conversation/message/Reply";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";
import RequestVita from "@/vue/communication/conversation/message/reply/RequestVita.vue";
import {APPLICANT_SENT_VITA} from "@/helper/communication/conversation/Status";
import _ from "lodash";

const FOLLOW_UP_MAKE_APPOINTMENT = 'make-appointment';
const FOLLOW_UP_REQUEST_VITA = 'request-vita';

export default {

	components: {
		RequestVita,
		Button,
		InfoBox,
		MakeAppointment,
		RadioGroup,
		FormGroup,
	},

	props: {
		message: {
			type: Object,
			required: true,
		},
		declinedVita: {
			type: Boolean,
			required: true,
		},
		sentVita: {
			type: Boolean,
			required: true,
		},
	},

	mounted ()
	{
		if (this.followUpOptions && this.followUpOptions.length === 1)
		{
			this.followUp = _.first(this.followUpOptions).value;
		}
	},

	data ()
	{
		return {
			followUp: undefined,
			followUps: {
				makeAppointment: FOLLOW_UP_MAKE_APPOINTMENT,
				requestVita: FOLLOW_UP_REQUEST_VITA,
			},
			makeAppointmentSuccess: false,
			sendingRequest: false,
			actionMakeAppointment: ACTION_MAKE_APPOINTMENT
		}
	},

	computed: {
		forcedFollowUp ()
		{
			if (this.message.messageConversationStatus.id === APPLICANT_SENT_VITA)
			{
				return FOLLOW_UP_MAKE_APPOINTMENT;
			}

			return undefined;
		},
		computedFollowUp ()
		{
			return this.forcedFollowUp ?? this.followUp;
		},
		applicantName ()
		{
			return this.message.disclosedData.name;
		},
		followUpOptions ()
		{
			let options = [{
				value: FOLLOW_UP_MAKE_APPOINTMENT,
				text: 'Termin mit ' + this.applicantName + ' vereinbaren',
			}];

			if (!this.declinedVita && !this.sentVita)
			{
				options.push({
					value: FOLLOW_UP_REQUEST_VITA,
					text: 'Einen Lebenslauf anfordern',
				});
			}

			return options;
		},
	},

	methods: {
		requestVita ()
		{
			this.sendRequest(ACTION_REQUEST_VITA);
		},
		async sendRequest (action)
		{
			this.sendingRequest = true;

			try
			{
				await new Reply()
					.setMessageId(this.message.id)
					.setAction(action)
					.call();

				this.$emit('processed');
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.sendingRequest = false;
		}
	}
}
</script>
